import * as React from "react";
import type { SvyTooltipProps } from "./SvyTooltip.interface";
import {
    Tooltip,
    TooltipContent,
    TooltipProvider,
    TooltipTrigger,
    type TooltipProviderProps,
} from "@radix-ui/react-tooltip";
import { StyledTooltipContent } from "./SvyTooltip.style";

export const SvyTooltip: React.FunctionComponent<SvyTooltipProps & TooltipProviderProps> = ({
    children,
    tooltipContent,
    ...props
}) => (
    <TooltipProvider data-testid="svy-tooltip" {...props}>
        <Tooltip>
            <TooltipTrigger asChild>{children}</TooltipTrigger>
            <TooltipContent>
                <StyledTooltipContent>{tooltipContent}</StyledTooltipContent>
            </TooltipContent>
        </Tooltip>
    </TooltipProvider>
);

SvyTooltip.displayName = "SvyTooltip";
